<div
  class="module-detail-view"
  [class.module-detail-view--dark]="isDarkMode"
  [class.module-detail-view--embedded]="embedded"
>
  <div class="module-detail-header" *ngIf="!embedded">
    <div>
      <p class="module-detail-eyebrow">Emission Performance</p>
      <h3 class="module-detail-title">{{ vesselName || 'Vessel Detail' }}</h3>
    </div>
    <div class="module-detail-actions">
      <button type="button" class="btn btn-light hover-button apply" (click)="back.emit()">
        Back to Database
      </button>
    </div>
  </div>

  <div class="module-detail-header module-detail-header--embedded" *ngIf="embedded">
    <div class="module-detail-header__vessel-badge" aria-hidden="true">
      <mat-icon>directions_boat</mat-icon>
    </div>
    <div class="module-detail-header__vessel-copy">
      <p class="module-detail-eyebrow">Selected Vessel</p>
      <h3 class="module-detail-title module-detail-title--compact">{{ vesselName || 'Vessel Detail' }}</h3>
    </div>
  </div>

  <div class="module-detail-loading" *ngIf="loading">
    <mat-spinner diameter="32"></mat-spinner>
    <span>Loading emission configuration…</span>
  </div>

  <div class="module-detail-sections module-detail-sections--compact-grid" *ngIf="!loading && visibleSections.length">
    <app-onboarding-editable-section
      *ngFor="let section of visibleSections; trackBy: trackSection"
      [section]="section"
      [isDarkMode]="isDarkMode"
      [saving]="savingSectionId === section.id"
      (save)="onSectionSave($event)"
    ></app-onboarding-editable-section>
  </div>

  <div class="module-detail-empty" *ngIf="!loading && !visibleSections.length">
    No emission configuration is available for this vessel yet.
    Sections appear here only when data has been onboarded for that service.
  </div>
</div>
